import { Tooltip } from "@material-ui/core";
import React from "react";
import PaginatedTableResults from "../../Base/Components/PaginatedTableResults";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Error from "@material-ui/icons/Error";
import { searchSecurityLogs } from "../../Base/Services/SecurityLogService";
import moment from "moment";
export default function AdminSecuritySearchResults({ inputSearchCriteria }) {
  const tableHeaders = [
    {
      headerName: "Date",
      getField: (row) => {
        let timeFromNow = moment(row.createdDate).fromNow();
        timeFromNow = timeFromNow.charAt(0).toUpperCase() + timeFromNow.slice(1);
        return (
          <Tooltip title={moment(row.createdDate).format("LLL")}>
            <span>{timeFromNow}</span>
          </Tooltip>
        );
      },
      sortBy: "createdDate",
    },
    {
      headerName: "User",
      getField: (row) => row.user.contactInformation.lastName + ", " + row.user.contactInformation.firstName,
      sortBy: "user.contactInformation.lastName,user.contactInformation.firstName",
    },
    {
      headerName: "API Path",
      getField: (row) => row.endpoint,
      sortBy: "endpoint",
    },
    {
      headerName: "Method",
      getField: (row) => row.requestMethod,
      sortBy: "requestMethod",
    },
    {
      headerName: "Query String",
      getField: (row) => (
        <Tooltip title={row.queryString || ""}>
          <div style={{ maxWidth: 200, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
            {row.queryString}
          </div>
        </Tooltip>
      ),
      sortBy: "queryString",
    },
    {
      headerName: "Status",
      getField: (row) => {
        return (
          <Tooltip title={"Status: " + row.responseStatus}>
            {row.responseStatus < 400 ? <CheckCircle style={{ color: "green" }} /> : <Error style={{ color: "red" }} />}
          </Tooltip>
        );
      },
      sortBy: "responseStatus",
    },
    {
      headerName: "Duration (ms)",
      getField: (row) => row.duration,
      sortBy: "duration",
    },
  ];

  return (
    <PaginatedTableResults
      inputSearchCriteria={inputSearchCriteria}
      tableColumns={tableHeaders}
      getTableResultsFunction={searchSecurityLogs}
      rowsPerPageOptions={[10, 25, 50, 100]}
    />
  );
}
